import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { getLineItemDisplay } from "@babackapp/return-widget-components/utils/line-item-display";
import type {
  DraftLineItem,
  OrderLineItem,
} from "@babackapp/return-widget-components/types";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
  currency: string;
};

export function CompleteReturnLineItem({
  item,
  orderLineItems,
  currency,
}: Props) {
  const { title, subtitle, image, price } = getLineItemDisplay(
    orderLineItems,
    item.lineItemId,
  );
  const totalPrice = (price ?? 0) * item.quantity;

  return (
    <Article>
      <ArticleImage
        src={image ?? undefined}
        layoutId={`img-complete-${item.lineItemId}`}
      />
      <ArticleTitle>{title}</ArticleTitle>
      <ArticleSubtitle>
        {subtitle && `${subtitle} · `}×{item.quantity}
        {totalPrice > 0 && ` · ${formatPrice(totalPrice, currency)}`}
      </ArticleSubtitle>
    </Article>
  );
}
